import React from "react";
import { Form, Checkbox, Table } from "antd";
import { COVERAGE_DATA } from "constants/insurance";

function buildCoverageRows() {
  const rows = [];
  COVERAGE_DATA.sections.forEach((section) => {
    if (section.subCoverages) {
      section.subCoverages.forEach((sub) => {
        let amountDisplay = `${sub.amount.toLocaleString()} ${sub.unit}`;
        if (sub.maxWeeks) {
          amountDisplay += ` (max ${sub.maxWeeks} weeks)`;
        }
        rows.push({
          key: sub.id,
          section: `${sub.id}`,
          description: sub.label,
          amount: amountDisplay,
        });
      });
    } else {
      rows.push({
        key: section.id,
        section: `Section ${section.id}`,
        description: section.title.replace(`Section ${section.id}: `, ""),
        amount: `${section.amount.toLocaleString()} ${section.unit}`,
      });
    }
  });
  return rows;
}

const columns = [
  {
    title: "Section",
    dataIndex: "section",
    key: "section",
    width: 80,
  },
  {
    title: "Coverage",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    width: 200,
  },
];

export default function CoverageSummarySection() {
  const dataSource = buildCoverageRows();

  return (
    <div>
      <h3>สรุปความคุ้มครอง (Coverage Summary)</h3>

      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        size="small"
        bordered
      />

      <div style={{ marginTop: 16, fontWeight: "bold", fontSize: 16 }}>
        เบี้ยประกันภัยรวม (Total Premium): {COVERAGE_DATA.premium} {COVERAGE_DATA.premiumCurrency} (รวมภาษีและอากร)
      </div>

      <Form.Item
        name="coverageAcknowledged"
        valuePropName="checked"
        rules={[
          {
            validator: (_, value) => {
              if (value) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("กรุณายืนยันว่าคุณได้ตรวจสอบความคุ้มครองแล้ว")
              );
            },
          },
        ]}
        style={{ marginTop: 16 }}
      >
        <Checkbox>
          ข้าพเจ้าได้ตรวจสอบรายละเอียดความคุ้มครองและยอมรับเงื่อนไขแล้ว
          (I have reviewed and acknowledge the coverage details)
        </Checkbox>
      </Form.Item>
    </div>
  );
}
